export enum TestIds {
  OverallEffectiveness = 'OverallEffectiveness',
  TestType = 'TestType',
}
